import {
    createProfileSchema,
    emptyProfileSchema,
    asProfilePost,
  } from '@meprism/shared/src/schemas/EmployeeProfileForm'
import {
    useForm,
    useFieldArray,
    SubmitHandler,
  } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useAppDispatch } from '../../redux/storeExports'
import { PostAdminUserSetup, FetchExecutiveUsers } from '@meprism/shared/src/redux/profile/ProfileSlice'
import { fetchCode } from '../../redux/corporateService'

export interface UseProfileFormProps {
    onSubmitSuccess?: () => void
    onSubmitError?: (error: any) => void
    middleNameOptional?: boolean
    linkedinOptional?: boolean
    streetOptional?: boolean
    agreeToTermsOptional?: boolean
  }


  export const useEmployeeProfileForm = (props: UseProfileFormProps) => {
    const dispatch = useAppDispatch()

    const profileSchema = createProfileSchema(
      Boolean(props.middleNameOptional),
      Boolean(props.linkedinOptional),
      Boolean(props.streetOptional),
      Boolean(props.agreeToTermsOptional),
    )

    const profilesSchema = z.object({
      profiles: z.array(profileSchema),
    })
  
    type ProfilesForm = z.infer<typeof profilesSchema>
  
    const {
      reset,
      register,
      control,
      handleSubmit,
      watch,
      setValue,
      trigger,
      formState: { errors },
    } = useForm<ProfilesForm>({
      resolver: zodResolver(profilesSchema),
      defaultValues: {
        profiles: [emptyProfileSchema()],
      },
      mode: 'onChange'
    })
  
    const {
      fields: profileFields,
      append,
      remove,
    } = useFieldArray({
      control,
      name: 'profiles',
    })
  
    const submitHandler: SubmitHandler<ProfilesForm> = async (profiles) => {
        try {
          const ProfilesToPost = formatProfilesToPost(profiles.profiles)
          const code = await dispatch(fetchCode()).unwrap()
          await dispatch(
            PostAdminUserSetup({
              profiles: ProfilesToPost,
              code: code,
            })
          )
          props.onSubmitSuccess?.()
          await dispatch(FetchExecutiveUsers(code))
        } catch (error) {
          console.log(`Error submitting profiles: ${error}`)
          props.onSubmitError?.(error)
        }
      }
    
    const formatProfilesToPost=(profiles: any[])=>{
        const profilesToPost: any[] = []
        profiles.map((profile)=>(
          profilesToPost.push(asProfilePost(profile))
        ))
        return profilesToPost
    }
  
    const addProfile = () => {
      append(emptyProfileSchema())
    }
  
    return {
      register,
      control,
      handleSubmit,
      submitHandler,
      profileFields,
      addProfile,
      remove,
      watch,
      errors,
      trigger,
      setValue, reset
    }
  }
  